<template>
  <div id="app-blank">
    <!-- Content without header or footer -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BlankLayout'
}
</script>

<style scoped>
#app-blank {
  min-height: 100vh;
  width: 100%;
}
</style>
